import moment from "moment";
import { LoadState } from "../../../constants/enums";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";

export interface IAccountingReportsState {
  list: IReports[];
  attachmentList: IReportAttachment[];
  listLoading: LoadState;
  data: IReports;
  dataLoading: LoadState;
  loading: LoadState;
  error: string | null;
  totalRecords: number;
}

export interface IReports {
  type: string;
  accn_transaction_report_history_code: string | null;
  sub_type: string;
  general_ledger_report: string;
  order_by: string;
  view: string;
  from_date: string | null;
  to_date: string | null;
  name: string[];
  branch_code: string[];
  insurer_code: string[];
  producer_one_code: string[];
  csr_code: string[];
  line_of_business: string[];
  payment_method: string[];
  policy_transaction_type: string[];
  policy_number: string[];
  effective_date: string[];
  policy_status: string[];
  transaction_type: string[];
  policy_type: string[];
  agency_or_direct_bill: string[];
  vendor: string[];
  vendor_type: string[];
  payment_terms: string[];
  category: string[];
  gl_account: string[];
  fields_to_exports: string[];
  attachment: IFileUpload[] | null;
  status: string;
  is_transaction_report_preview: number;
  reconciled: string | null;
  send_report_email: boolean | null;
}

export interface IReportAttachment {
  accn_reports_attachment_id: number | null;
  report_code: string;
  producer_code: string;
  producer_email: string;
  time: string | null;
  report_type: string;
  attachment: string[];
  status: string;
  created_by_id?: number;
  modified_by_id?: number;
  branch_code: string | null;
  report_email: string | null;
  create_ts:  string | null;
  employment_status: string | null;
  incremental_number: string | null;
  name: string | null;
  producer_status: string | null;
  sub_type: string | null;
  total_branch: string | null;
  total_commission: string | null;
  total_house: string | null;
  total_invoices: string | null;
  total_payables: string | null;
  total_premium: string | null;
  non_active_firm: string | null;
  non_active_firm_name: string | null;
  total_producer: string | null;
  employee_number: string | null;
  commission_report_code: string | null;
  user_fact_id: string | null;
}

export const initialReportAttachment: IReportAttachment = {
  accn_reports_attachment_id: null,
  report_code: "",
  producer_code: "",
  producer_email: "",
  time: null,
  report_type: "",
  attachment: [],
  status: "",
  branch_code: null,
  report_email: null,
  create_ts: null,
  employment_status: null,
  incremental_number: null,
  name: null,
  producer_status: null,
  sub_type: "producer",
  total_branch: null,
  total_commission: null,
  total_house: null,
  total_invoices: null,
  total_payables: null,
  total_premium: null,
  non_active_firm: null,
  non_active_firm_name: null,
  total_producer: null,
  employee_number: null,
  commission_report_code: null,
  user_fact_id: null,
};

export const initialAccountingReportsState: IAccountingReportsState = {
  list: [],
  attachmentList: [],
  dataLoading: LoadState.NotLoaded,
  listLoading: LoadState.NotLoaded,
  data: {
    type: "",
    accn_transaction_report_history_code: null,
    sub_type: "",
    general_ledger_report: "",
    order_by: "invoice_date",
    view: "",
    from_date: moment()
      .startOf("month")
      .subtract(2, "months")
      .format("YYYY-MM-DD"),
    to_date: moment().endOf("month").subtract(2, "months").format("YYYY-MM-DD"),
    name: ["All"],
    branch_code: ["All"],
    insurer_code: ["All"],
    producer_one_code: ["All"],
    csr_code: ["All"],
    line_of_business: ["All"],
    payment_method: ["All"],
    policy_transaction_type: ["All"],
    policy_number: ["All"],
    effective_date: ["All"],
    policy_status: ["All"],
    transaction_type: ["All"],
    policy_type: ["All"],
    agency_or_direct_bill: ["All"],
    vendor: ["All"],
    vendor_type: ["All"],
    payment_terms: ["All"],
    category: ["All"],
    gl_account: ["All"],
    fields_to_exports: [],
    attachment: null,
    status: "ACTIVE",
    is_transaction_report_preview: 0,
    reconciled: null,
    send_report_email: null,
  },
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  error: null,
};
